module.exports = __webpack_public_path__ + "static/img/hwzc.c77fa2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hwzc.jpg
// module id = e0J/
// module chunks = 0